<div *ngIf="cartData?.show" class="content" (click)="redirect()">
	<div class="img">
		<img class="bene" [src]="cartData?.fundraiser?.beneficiary?.avtar?.cdn_path || cartData?.fundraiser?.media_beneficiary?.cdn_path" alt="">
		<img class="heart" src="/assets/images/heartfilled.svg" alt="heart">
	</div>
	<div class="text-container">
		<div class="title">You are <span>one</span> click away!</div>
		<div class="text">Be a hero in {{cartData?.fundraiser?.beneficiaryname?.info_1?.trim()}}'s life.</div>
	</div>
	<div class="btn">Donate</div>
	<div (click)="close()" class="cross">
		<span class="material-icons">close</span>
	</div>
</div>